import { useState } from "react";
import backgroundOrange from "../../../assets/images/inicio/fondo contacto.png";
import locationIcon from "../../../assets/images/inicio/icono_ubicacion.png";
import logo from "../../../assets/images/inicio/logo el industrial.png";
import phoneIcon from "../../../assets/images/inicio/icono_phone.png";
import whaIcon from "../../../assets/images/inicio/icono_whastapp.png";
import { toast } from "sonner";
import mailIcon from "../../../assets/images/inicio/icono_correo.png";
import "./SectionContact.css";

const SectionContact = () => {
  const initialState = {
    nombre: "",
    telefono: "",
    asunto: "",
    correo: "",
    mensaje: "",
  };
  const [data, setData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (
      data["nombre"] === "" ||
      data["telefono"] === "" ||
      data["asunto"] === "" ||
      data["correo"] === "" ||
      data["mensaje"] === ""
    ) {
      toast.error("Todos los campos son obligatorios");
      return;
    }

    fetch("/revista/contacto.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.message);
          setData(initialState);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => toast.error("Ocurrio un error"));
  };

  return (
    <section className="bg-contact-section">
      <img
        src={backgroundOrange}
        alt="Fondo Contacto"
        className="contact-bg-image"
        loading="lazy"
      />

      <div className="contact-bg-content">
        <div className="contact-content">
          {/* Columna Izquierda: Formulario */}
          <div className="left-contact-columns">
            <h2 className="contact-title">
              ¿Quieres publicarte en nuestras Revistas?
            </h2>

            <h3 className="contact-subtitle">Informes</h3>

            <form className="contact-form" onSubmit={handleFormSubmit}>
              <input
                type="text"
                name="nombre"
                value={data.nombre}
                onChange={handleChange}
                placeholder="Nombre:"
              />
              <input
                type="text"
                name="telefono"
                value={data.telefono}
                onChange={handleChange}
                placeholder="Teléfono:"
              />
              <input
                type="email"
                name="correo"
                value={data.correo}
                onChange={handleChange}
                placeholder="Correo electrónico:"
              />
              <input
                type="text"
                name="asunto"
                value={data.asunto}
                onChange={handleChange}
                placeholder="Asunto:"
              />
              <textarea
                placeholder="Mensaje:"
                rows="5"
                value={data.mensaje}
                onChange={handleChange}
                name="mensaje"
              />

              <button type="submit">Enviar</button>
            </form>
          </div>

          {/* Columna Derecha: Información de contacto */}
          <div className="right-contact-columns">
            <img
              src={logo}
              alt="Logo"
              className="contact-logo"
              loading="lazy"
            />

            <div className="contact-info-box">
              <h2 className="contact-box-title">Contacto</h2>

              <div className="contact-item">
                <img
                  src={whaIcon}
                  alt="Ubicación"
                  className="icon"
                  loading="lazy"
                />
                <img
                  src={phoneIcon}
                  alt="Ubicación"
                  className="icon"
                  loading="lazy"
                />
                <p>81 2724 9484</p>
              </div>

              <div className="contact-item">
                <img
                  src={mailIcon}
                  alt="Ubicación"
                  className="icon"
                  loading="lazy"
                />
                <p>ventas@revistaelindustrial.mx</p>
              </div>

              <div className="contact-item">
                <img
                  src={locationIcon}
                  alt="Ubicación"
                  className="icon"
                  loading="lazy"
                />
                <p>Monterrey, N.L.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionContact;
